module.exports = __webpack_public_path__ + "static/media/message-dots.616a8732.svg";